/**
 * DashboardChart.js
 * Reusable chart wrapper for the dashboard.
 * Uses Chart.js via react-chartjs-2 with project-consistent styling.
 */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import { CHART_DEFAULTS } from "./newDashboardData";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Filler,
  Tooltip,
  Legend,
);

// Apply global defaults
ChartJS.defaults.font.family = CHART_DEFAULTS.font.family;
ChartJS.defaults.font.size = CHART_DEFAULTS.font.size;
ChartJS.defaults.color = CHART_DEFAULTS.color;
ChartJS.defaults.plugins.legend.labels.usePointStyle =
  CHART_DEFAULTS.legend.usePointStyle;
ChartJS.defaults.plugins.legend.labels.pointStyleWidth =
  CHART_DEFAULTS.legend.pointStyleWidth;
ChartJS.defaults.plugins.legend.labels.padding = CHART_DEFAULTS.legend.padding;
ChartJS.defaults.plugins.legend.labels.color = CHART_DEFAULTS.legend.color;
ChartJS.defaults.plugins.tooltip.backgroundColor =
  CHART_DEFAULTS.tooltip.backgroundColor;
ChartJS.defaults.plugins.tooltip.titleColor = CHART_DEFAULTS.tooltip.titleColor;
ChartJS.defaults.plugins.tooltip.bodyColor = CHART_DEFAULTS.tooltip.bodyColor;
ChartJS.defaults.plugins.tooltip.borderColor =
  CHART_DEFAULTS.tooltip.borderColor;
ChartJS.defaults.plugins.tooltip.borderWidth =
  CHART_DEFAULTS.tooltip.borderWidth;
ChartJS.defaults.plugins.tooltip.cornerRadius =
  CHART_DEFAULTS.tooltip.cornerRadius;
ChartJS.defaults.plugins.tooltip.padding = CHART_DEFAULTS.tooltip.padding;

const CHART_MAP = {
  bar: Bar,
  line: Line,
  doughnut: Doughnut,
};

const DashboardChart = ({ config, height = 220 }) => {
  if (!config) return null;

  const ChartComponent = CHART_MAP[config.type];
  if (!ChartComponent) return null;

  return (
    <div style={{ position: "relative", width: "100%", height: `${height}px` }}>
      <ChartComponent data={config.data} options={config.options} />
    </div>
  );
};

export default DashboardChart;
